import axios from 'axios';
import { ENGAGEMENT_DASHBOARD } from '../../core/constants/endpoints';
import getAnalyticsHeaders from '../../core/utils/analyticsHeaders';

export const getEmbeddedDashboardUrl = ({
  spaceId,
  sessionToken,
  userId,
}) => async () => {
  const result = await axios.get(ENGAGEMENT_DASHBOARD(), {
    params: {
      spaceId,
    },
    headers: {
      ...getAnalyticsHeaders(),
      'x-session-token': sessionToken,
      'x-user-id': userId,
    },
  });
  const { url } = result.data;
  return url;
};

export default getEmbeddedDashboardUrl;
